/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Active.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  position: "absolute",
top: 0,
left: 0,
width: 320,
height: 200,
backgroundColor: "rgb(255,195,48)",
background: "linear-gradient(130deg, rgba(212, 212, 30,1) 0%, rgba(84, 212, 30,1) 61%, rgba(0,188,112,1) 100%)",
borderBottomLeftRadius: 8,
borderBottomRightRadius: 8,
borderTopLeftRadius: 8,
borderTopRightRadius: 8,
zIndex: 1})
styles.Vertical1 = css({label: 'Vertical1',
  position: "absolute",
top: 0,
left: 0,
width: 320,
height: 200,
borderBottomLeftRadius: 50,
borderBottomRightRadius: 50,
borderTopLeftRadius: 50,
borderTopRightRadius: 50,
backgroundColor: "transparent",
boxShadow: "-10px 0px 20px 0px rgba(212, 212, 30,0.4)"})
styles.Vertical2 = css({label: 'Vertical2',
  position: "absolute",
top: 0,
left: 0,
width: 320,
height: 200,
borderBottomLeftRadius: 50,
borderBottomRightRadius: 50,
borderTopLeftRadius: 50,
borderTopRightRadius: 50,
backgroundColor: "transparent",
boxShadow: "10px 0px 20px 0px rgba(0,188,112,0.4)"})

export default function Active({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Verify/Result/Match/MemberCard/Status/Active"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Active.Vertical"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard/Status/Active"
 className={`views-block ${styles.Vertical}`}
/>
<div
 data-testid="Active.Vertical:1"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard/Status/Active"
 className={`views-block ${styles.Vertical1}`}
/>
<div
 data-testid="Active.Vertical:2"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard/Status/Active"
 className={`views-block ${styles.Vertical2}`}
/>
{children}
</React.Fragment>)
}